
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(19),
  playerId: Number.withConstraint(x => x >= 0),
  customHash: String.withConstraint(x => x.length <= 30),
  testId: Number.withConstraint(x => x >= 0 && x <= 65535),
  caseId: Number.withConstraint(x => x >= 0 && x <= 16777215),
  accountHash: String.withConstraint(x => x.length <= 30),
  partnerId: Number.withConstraint(x => x >= 0 && x <= 65535),
  creativeId: Number.withConstraint(x => x >= 0),
  event_mapping_version: Literal(2),
}).And(Partial({
  crna: String.withConstraint(x => x.length <= 100),
  countryCode: String.withConstraint(x => x.length <= 2),
  useragent: String,
  loginClickerCookie: Number.withConstraint(x => x >= 0 && x <= 1),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(19),
  playerId: Number.withConstraint(x => x >= 0),
  customHash: String.withConstraint(x => x.length <= 30),
  testId: Number.withConstraint(x => x >= 0 && x <= 65535),
  caseId: Number.withConstraint(x => x >= 0 && x <= 16777215),
  accountHash: String.withConstraint(x => x.length <= 30),
  partnerId: Number.withConstraint(x => x >= 0 && x <= 65535),
  creativeId: Number.withConstraint(x => x >= 0),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
}).And(Partial({
  crna: String.withConstraint(x => x.length <= 100),
  countryCode: String.withConstraint(x => x.length <= 2),
  useragent: String,
  loginClickerCookie: Number.withConstraint(x => x >= 0 && x <= 1),
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 19;
  